import { css } from '@emotion/react';
import { theme } from '../../theme/theme';
import type { StatTileTone } from './StatTile';

const toneColor: Record<StatTileTone, string> = {
  neutral: theme.color.text,
  success: theme.color.success,
  warning: theme.color.warning,
  info: theme.color.running,
  danger: theme.color.danger,
};

/** 테두리에 상태색을 쓰는 톤. neutral·info는 기본 테두리 유지. */
const borderToned: StatTileTone[] = ['success', 'warning', 'danger'];

export const statTileStyle = (tone: StatTileTone) => css`
  padding: ${theme.space.md}px;
  border: 1px solid ${borderToned.includes(tone) ? `${toneColor[tone]}66` : theme.color.border};
  border-radius: ${theme.radius.md}px;
  background: ${tone === 'danger' ? `${theme.color.danger}0D` : theme.color.surface};
`;

export const statLabelStyle = (tone: StatTileTone) => css`
  font-size: ${theme.fontSize.sm}px;
  color: ${tone === 'danger' ? theme.color.danger : theme.color.textMuted};
  font-weight: ${tone === 'danger' ? 500 : 400};
`;

export const statValueStyle = (tone: StatTileTone) => css`
  margin-top: ${theme.space.xs}px;
  font-size: ${theme.fontSize.xl}px;
  font-weight: 700;
  color: ${tone === 'neutral' ? theme.color.text : toneColor[tone]};
`;

export const statCaptionStyle = (tone: StatTileTone) => css`
  margin-top: ${theme.space.xs}px;
  font-size: ${theme.fontSize.sm}px;
  color: ${tone === 'danger' ? theme.color.danger : theme.color.textMuted};
`;
